module.exports = __webpack_public_path__ + "img/Logins@_borderRadius.831d77cb.svg";